"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get UserLikeNLikePgHandler () {
        return UserLikeNLikePgHandler;
    },
    get UserPgHandler () {
        return UserPgHandler;
    }
});
const _genericpg = require("../generic.pg");
const _usergeneralhandler = require("./user.general.handler");
const _pg = require("~/db/aggregations/pg");
let UserLikeNLikePgHandler = class UserLikeNLikePgHandler extends _usergeneralhandler.UserGeneralHandler {
    replaceDelimitedWithKeyValue(param) {
        const { knex, needleColumn, stack } = param;
        return `(${(0, _pg.replaceDelimitedWithKeyValuePg)({
            knex,
            needleColumn,
            stack
        })})`;
    }
    constructor(...args){
        super(...args), this.singleLineTextHandler = new _genericpg.GenericPgFieldHandler();
    }
};
let UserPgHandler = class UserPgHandler extends _genericpg.GenericPgFieldHandler {
    constructor(...args){
        super(...args), this.userHandler = new UserLikeNLikePgHandler(), this.filter = this.userHandler.filter, this.filterLike = this.userHandler.filterLikeNlike, this.filterNlike = this.userHandler.filterLikeNlike, this.parseUserInput = this.userHandler.parseUserInput, this.singleLineTextHandler = this.userHandler.singleLineTextHandler, this.replaceDelimitedWithKeyValue = this.userHandler.replaceDelimitedWithKeyValue;
    }
};
